export class IframeOpener {
  private openIframeButton: HTMLButtonElement;
  private iframeElement: HTMLIFrameElement | null = null;

  private widgetData: {
    containerSelector: string;
    buttonName: string;
    iframeUrl: string;
    type: string;
    module: string;
    version: string;
    customClassName: string;
  };
  private styleReadyPromise: Promise<void>;

  constructor(widgetData: {
    containerSelector: string;
    buttonName: string;
    iframeUrl: string;
    type: string;
    module: string;
    version: string;
    customClassName: string;
  }) {
    this.injectClientStyle('https://widget-v1.dabadu.dev/widget/css/widget.css');

    this.widgetData = widgetData;

    // Create and style the button
    this.openIframeButton = this.createButton();
    // this.containerElement.appendChild(this.openIframeButton);

    // Initialize iframe connection
    this.handleConnectIframe();

    // Setup event listeners
    this.setupEventListeners();
  }

  render(parentElement: HTMLElement): void {
    parentElement.appendChild(this.openIframeButton);
  }

  // render(parentElement: HTMLElement): void {
  //   this.styleReadyPromise.then((red) => {
  //     console.log('Styles loaded successfully, rendering button', red);
  //     // Create button only after CSS is loaded
  //     if (!this.openIframeButton) {
  //       this.openIframeButton = this.createButton();
  //     }

  //     if (!parentElement.contains(this.openIframeButton)) {
  //       parentElement.appendChild(this.openIframeButton);
  //     }
  //   });
  // }

  private injectDefaultStyles() {
    const style = document.createElement('style');
    style.textContent = `
      .default-iframe-button {
        // background-color: #5e50f1;
        color: white;
        border: 1px solid #5e50f1;
        border-radius: 0px;
        padding: 11px 14px;
        cursor: pointer;
        letter-spacing: 0.5px;
        font-weight: 500;
        outline: none;
        visibility: hidden;
      }
    `;
    document.head.appendChild(style);
  }

  private createButton(): HTMLButtonElement {
    const button = document.createElement('button');
    button.className = `dabadu-widget-button ${this.widgetData.customClassName} `;
    // Generate a unique ID for each button
    const uniqueId = `open-iframe-button-${Math.random().toString(36).substring(2, 11)}`;
    button.id = uniqueId;
    button.textContent = this.widgetData.buttonName;

    // Apply default and custom styles
    // button.style.cssText = `
    //   // background-color: #5e50f1;
    //   color: white;
    //   border: 1px solid transparent;
    //   border-radius: 0px;
    //   padding: 11px 14px;
    //   cursor: pointer;
    //   letter-spacing: 0.5px;
    //   font-weight: 500;
    //   outline: none;
    //   visibility: hidden;
    // `;

    // if (this.widgetData.customClassName) {
    //   // button.className = this.widgetData.customClassName;
    //   button.classList.add(this.widgetData.customClassName);
    // }
    // button.classList.add('default-iframe-button');
    // button.className = `dabadu-widget-button ${this.widgetData.customClassName} `;

    button.addEventListener('click', this.handleOpenIframe.bind(this));

    return button;
  }

  private handleOpenIframe(): void {
    // Ensure previous iframe is removed
    this.removeExistingIframe();

    // Create new iframe
    this.iframeElement = this.createIframe();
    this.iframeElement.style.cssText = `
      width: 100vw;
      height: 100vh;
      border: none;
      position: fixed;
      top: 0;
      left: 0;
      z-index: 1000000;
      display: block;
    `;
    document.body.appendChild(this.iframeElement);

    // Disable scrolling on the body
    document.body.style.overflow = 'hidden';

    window.postMessage({ eventType: 'widgetOpened', data: { module: this.widgetData.module } }, '*');
  }

  private handleConnectIframe(): void {
    this.removeExistingIframe(); // Ensure no duplicate iframes
    this.iframeElement = this.createIframe();
    this.iframeElement.style.visibility = 'hidden';
    if (!document.getElementById(`${this.widgetData.module}-in-button`)) {
      document.body.appendChild(this.iframeElement);
    }
  }

  private handleIframeClose(): void {
    this.removeExistingIframe();
    document.body.style.overflow = '';
    window.postMessage({ eventType: 'widgetClosed', data: { module: this.widgetData.module } }, '*');
  }

  private createIframe(): HTMLIFrameElement {
    const iframe = document.createElement('iframe');
    iframe.id = `${this.widgetData.module}-in-button`;
    iframe.name = `${this.widgetData.module}-in-button`;

    iframe.src = `https://widget-v1.dabadu.dev/${this.widgetData.module}/${this.widgetData.token}?domain=${window.location.origin}&type=${this.widgetData.type}&version=${this.widgetData.version}`;

    iframe.className = 'tradein-Class';
    return iframe;
  }

  private removeExistingIframe(): void {
    if (this.iframeElement) {
      this.iframeElement.remove();
      this.iframeElement = null;
    }
  }

  private setupEventListeners(): void {
    window.addEventListener('message', (event) => {
      if (!event.data || !event.data.res) return;

      const { type, res } = event.data;

      // ✅ Only process messages that match this instance's module
      if (res.module !== this.widgetData.module) {
        return; // Ignore messages meant for other buttons
      }

      const closeEventType = `${this.widgetData.module}-modal-close`;
      const openEventType = `${this.widgetData.module}-modal-open-btn`;

      if (res?.auth === false && res?.type === 'button') {
        const button = this.openIframeButton;
        if (button) {
          button.remove();
          this.removeExistingIframe();
        }
      }

      if (type === closeEventType) {
        this.handleIframeClose();
      } else if (type === openEventType) {
        this.handleIframeOpen(event.data);
      } else {
        console.warn('Unhandled message type:', type);
      }
    });
  }

  private injectClientStyle(styleUrl: string): void {
    if (document.querySelector(`link[href="${styleUrl}"]`)) return; // Avoid duplicates

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = styleUrl;
    link.crossOrigin = 'anonymous'; // Optional, based on hosting
    document.head.appendChild(link);
  }

  private injectClientStyle_(styleUrl: string): Promise<void> {
    return new Promise((resolve, reject) => {
      // Avoid duplicates
      if (document.querySelector(`link[href="${styleUrl}"]`)) {
        resolve();
        return;
      }

      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = styleUrl;
      link.crossOrigin = 'anonymous';
      link.onload = () => resolve(); // ✅ wait for stylesheet to load
      link.onerror = () => reject(new Error(`Failed to load style: ${styleUrl}`));
      document.head.appendChild(link);
    });
  }

  private generateClientWidgetClass(clientName: string, widgetType: string) {
    const safeClient = clientName
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/(^-|-$)/g, '');
    const safeWidget = widgetType
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/(^-|-$)/g, '');
    return `dabadu-${safeClient}-${safeWidget}`;
  }

  private setScopedClientVariables(className: string, vars: object) {
    const style = document.createElement('style');
    const varDeclarations = Object.entries(vars)
      .map(([key, val]) => `--${key}: ${val};`)
      .join('\n');

    style.textContent = `
    .${className} {
      ${varDeclarations}
    }
  `;
    document.head.appendChild(style);
  }

  private handleIframeOpen(response: any): void {
    const { type, res } = response || {};

    const openEventType = `${this.widgetData.module}-modal-open-btn`;

    if (res.success && type === openEventType) {
      const button = this.openIframeButton;

      if (button) {
        this.injectClientStyle('https://widget-v1.dabadu.dev/widget/css/widget.css');

        // document.documentElement.style.setProperty(`--primary-color`, res.primaryColor || '#5e50f1');
        const className = this.generateClientWidgetClass(res?.clientName, res?.module);
        // button.className = `dabadu-widget-button`;
        button.classList.add(className);
        this.setScopedClientVariables(className, {
          'primary-color': res?.primaryColor,
        });

        button.style.visibility = 'visible';
        // button.style.backgroundColor = res.primaryColor || '#5e50f1';
        // button.style.borderColor = res.primaryColor || '#5e50f1';
        button.textContent =
          res.buttonName || (res?.widgetName === 'Credit Score' ? 'PRE-QUALIFY NOW' : 'Free Trade-In Estimate');
      }
    } else if (!res.success && type === openEventType) {
      const button = this.openIframeButton;
      if (button) {
        button.remove();
        this.removeExistingIframe();
      }
    }
  }
}
